import styled from 'styled-components';
import { colors, mixins, fonts } from '../../css';

export const NumberContainer = styled.div`
  font-size: ${mixins.pxToRem(12)};
  color: ${colors.colorGrey03};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const NumberToggleWrapper = styled.div`
  min-width: 20px;
  max-width: 90px;
  position: relative;
  text-align: center;
  display: flex;
  justify-content: center;
  flex-direction: row-reverse;
  align-items: center;
  color: ${colors.colorGrey};
`;

export const NumberToggleUp = styled.button`
  width: 30px;
  height: ${mixins.pxToRem(25)};
  margin: 0;
  position: relative;
  color: ${colors.colorGrey02};
  cursor: pointer;

  &:before,
  &:after {
    content: '';
    width: 65%;
    height: 2px;
    display: block;
    position: absolute;
    bottom: 50%;
    right: 50%;
    transform: translate(50%, 50%);
    background: ${colors.colorGrey03};
  }
  &:after {
    content: '';
    width: 2px;
    height: 65%;
  }

  &.disabled:before,
  &.disabled:after {
    background: ${colors.colorGrey04};
  }
`;
export const NumberToggleInput = styled.input`
  width: 100%;
  height: calc(100% - 70px);
  position: absolute;
  display: block;
  overflow: visible;
  font-family: ${fonts.fontBold};
  line-height: 40px;
  text-align: center;
  -moz-appearance: textfield;
  color: transparent;
  background: transparent;
  border: none;
  font-size: ${mixins.pxToRem(16)};
  width: 40px;

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
  }
`;

export const NumberToggleInputClone = styled.div`
  width: 100%;
  padding-top: 0.2em;
  font-family: ${fonts.fontBold};
  font-size: 40px;
  line-height: 40px;
  font-size: ${mixins.pxToRem(16)};
  width: 40px;

  &.disabled {
    color: ${colors.colorGrey03};
  }
`;

export const NumberToggleDown = styled.button`
  width: 30px;
  height: ${mixins.pxToRem(25)};
  margin: 0;
  position: relative;
  color: ${colors.colorGrey02};
  cursor: pointer;

  &:before {
    content: '';
    width: 65%;
    height: 2px;
    display: block;
    position: absolute;
    bottom: 50%;
    right: 50%;
    transform: translate(50%, 50%);
    background: ${colors.colorGrey03};
  }

  &.disabled:before {
    background: ${colors.colorGrey04};
  }
`;
